/* eslint-disable better-mutation/no-mutation */

import { createSlice } from '@reduxjs/toolkit';
import getInitialState, { MODAL_STATUS } from './initial-state';
import { getPaymentOptions, getInvoice } from './actions';

const invoiceCheckoutSlice = createSlice({
    name: 'invoiceCheckout',
    initialState: getInitialState(),
    reducers: {
        setInvoiceData: (state, { payload }) => {
            state.invoice = payload;
        },
        setSelectedPayment: (state, { payload }) => {
            state.payment.selectedPayment = payload;
            state.payment.paymentMethodData = null;
            state.checkoutSummary.hasError = false;
        },
        setPaymentMethodData: (state, { payload }) => {
            state.payment.paymentMethodData = payload;
        },
        setPaymentPaying: (state, { payload }) => {
            state.payment.isPaying = payload;
            state.payment.hasError = false;
        },
        setCheckoutSummaryFetching: (state, { payload }) => {
            state.checkoutSummary.isFetching = payload;
            state.checkoutSummary.hasError = false;
            state.isUpdating = payload;
        },
        setCheckoutSummaryHasError: (state, { payload }) => {
            state.checkoutSummary.hasError = payload;
            state.checkoutSummary.isFetching = false;
            state.isUpdating = false;
            state.payment.modal.status = MODAL_STATUS.ERROR;
        },
        openPaymentModal: (state, { payload }) => {
            const { open, status, paymentAttemptId } = payload;
            state.payment.modal = {
                open,
                status,
                paymentAttemptId
            };
        },
        closePaymentModal: state => {
            state.payment.modal = {
                open: '',
                status: MODAL_STATUS.START
            };
        },
        resetOngoingPaymentAttempt: state => {
            state.ongoingPaymentAttempt = {
                invoicePaymentAttemptId: null,
                paymentMethod: null
            };
        }
    },
    extraReducers: builder => {
        // get invoice
        builder.addCase(getInvoice.fulfilled, (state, { payload }) => {
            state.invoice = {
                ...state.invoice,
                ...payload.invoice,
                isFetching: false
            };
            state.sellerPhoneNumber = payload.sellerPhone;
            state.ongoingPaymentAttempt = {
                ...state.ongoingPaymentAttempt,
                ...payload.ongoingPaymentAttempt
            };
        });
        builder.addCase(getInvoice.pending, state => {
            state.invoice = {
                ...state.invoice,
                isFetching: true,
                hasError: null
            };
        });
        builder.addCase(getInvoice.rejected, state => {
            state.invoice = {
                ...state.invoice,
                isFetching: false,
                hasError: true
            };
        });

        // get payment options
        builder.addCase(getPaymentOptions.fulfilled, (state, { payload }) => {
            const { paymentOptions } = payload;
            state.payment = {
                ...state.payment,
                isFetching: false,
                paymentOptions: paymentOptions
            };
        });
        builder.addCase(getPaymentOptions.pending, state => {
            state.payment = {
                ...state.payment,
                isFetching: true,
                hasError: null
            };
        });
        builder.addCase(getPaymentOptions.rejected, state => {
            state.payment = {
                ...state.payment,
                isFetching: false,
                hasError: true
            };
        });
    }
});

export const {
    openNonIntegratedModal,
    closeNonIntegratedModal,
    setSelectedPayment,
    setPaymentMethodData,
    setPaymentPaying,
    setCheckoutSummaryFetching,
    setCheckoutSummaryHasError,
    openPaymentModal,
    closePaymentModal,
    setTermsAccepted,
    setInvoiceData,
    resetOngoingPaymentAttempt
} = invoiceCheckoutSlice.actions;

export default invoiceCheckoutSlice.reducer;
